import React from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';

// ===============================|| UI DIALOG - SWEET ALERT ||=============================== //

export default function RedQuickAlert(props: any) {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {props.button ? React.cloneElement(props.button, {
                onClick: handleClickOpen
            }) : <Button variant="outlined" onClick={handleClickOpen}>
                {props.buttonText}
            </Button>}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{ p: 3 }}
            >
                <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Typography variant="body2" component="span">
                            {props.description}
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ pr: 2.5 }}>
                    <Button
                        sx={{ color: theme.palette.error.dark, borderColor: theme.palette.error.dark }}
                        onClick={() => {
                            handleClose();
                        }}
                        color="secondary"
                    >
                        {props.cancelText}
                    </Button>
                    <Button variant="contained" size="small" onClick={() => {
                        handleClose();
                        if (props.onOk) {
                            props.onOk();
                        }
                    }} autoFocus>
                        {props.affirmativeText}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
